// Takes the type field like 'inside-out-publications' and swaps dashes for spaces so it can
// be displayed nicely in the tile.
export const typeToDescription = type => {
	// private-practitioner becomes Private Practitioner
	return type
		.split('-')
		.map(word => word.charAt(0).toUpperCase() + word.substring(1))
		.join(' ');
};

export const treatmentServicesTypes = [
	{ label: 'Private Practitioner', value: 'private-practitioner' },
	{ label: 'Community Clinic or Program', value: 'community-clinic-or-program' },
	{ label: 'Day program', value: 'day-program' },
	{ label: 'In Hospital Treatment (Public or Private Services)', value: 'in-hospital-treatment' },
	{ label: 'Support Group', value: 'support-group' },
	{ label: 'Clinical Supervision (for health professionals only)', value: 'clinical-supervision' },
];

export const treatmentServicesDisciplines = {
	'psychiatrist': 'Psychiatrist',
	'paediatrician': 'Paediatrician',
  'general-practitioner': 'General Practitioner (GP)',
	'medical-professional': 'Medical Professional',
	'clinical-psychologist': 'Clinical Psychologist',
	'psychologist': 'Psychologist',
	'accredited-practising-dietitian': 'Accredited Practising Dietitian',
	'registered-nurse': 'Registered Nurse',
	'occupational-therapist': 'Occupational Therapist',
	'exercise-physiologist': 'Exercise Physiologist',
	'physiotherapist': 'Physiotherapist',
	'counsellor': 'Counsellor',
	'social-worker': 'Social Worker',
	'art-therapist': 'Art Therapist',
	'psychotherapist': 'Psychotherapist',
};

export const treatmentServicesAgeRanges = {
  'children': 'Children & Adolescents (up to 18 years of age)',
  'youth': 'Youth (14 - 24 years of age)',
  'adults': 'Adults (18 years and over)',
};



// WEBPACK FOOTER //
// ./src/managers/treatmentServicesManager.js